import axios, { type AxiosResponse, type InternalAxiosRequestConfig } from "axios";

export default defineNuxtPlugin(() => {
    const { getItem, clear } = useLocalStorage();

    const $axios = axios.create({
        baseURL: 'https://dmz-backend.bizi.one/api/v1',
        withCredentials: true,
    });

    $axios.interceptors.request.use((request: InternalAxiosRequestConfig) => {
        const accessToken = getItem(ACCESS_TOKEN_KEY);
        if(accessToken) request.headers['Authorization'] = `bearer ${accessToken}`;
        return request;
    }, (error) => {
        return Promise.reject(error);
    });

    $axios.interceptors.response.use((response: AxiosResponse) => {
        if(response.status == 401) {
            clear();
            window.location.href = '/';
        }
        return response;
    }, (error) => {
        const response = error.response;
        if(response && response.status == 401) {
            const cookie = useCookie(SESSION_COOKIE_KEY);
            clear();
            cookie.value = null;
            window.location.href = '/';
        }
        return Promise.reject(error);
    });

    return {
        provide: {
            axios: $axios,
        }
    }
})
